import { Flex } from '@chakra-ui/react';
import { Paragraph } from 'ui-components';
import { GroupedFilters } from '~/screens/MyAgency/hooks/useGroupFilters';
import {
  useAdvancedFiltersStore,
  useCreatorsFiltersStore,
} from '~/screens/MyAgency/store';
import { convertPxToRems } from '~/utils-ts';

import { AdvancedFilterPill, AdvancedFilterPillV2 } from './AdvancedFilterPill';
import { AppliedCreatorFilters } from './AppliedCreatorFilters';

interface Props {
  isShared: boolean;
  filters: GroupedFilters[];
  enabledControls: string[];
  newFilterPill?: boolean;
}

export const AppliedAdvancedFilters: React.FC<Props> = ({
  isShared,
  filters,
  enabledControls,
  newFilterPill,
}) => {
  const { clearFilters } = useAdvancedFiltersStore({
    // if new UI is enabled, we dont clear the platform on removing every filter,
    // as that breaks the UX expectations of the new platform picker
    clearPlatform: !newFilterPill,
  });

  const { appliedFilters } = useCreatorsFiltersStore();

  const FilterPill = newFilterPill ? AdvancedFilterPillV2 : AdvancedFilterPill;

  if (filters.length === 0 && appliedFilters.length === 0) return null;

  return (
    <Flex
      marginY={newFilterPill ? 0 : convertPxToRems(16)}
      columnGap={convertPxToRems(4)}
      rowGap={convertPxToRems(8)}
      wrap="wrap"
      track-id="foam-myagency-badgecontainer"
    >
      {newFilterPill && (
        <Paragraph
          as="span"
          sx={{
            gap: 'spacing-100',
            display: 'inline-flex',
            alignItems: 'center',
          }}
          size="sm"
          color="primary.400"
        >
          Filters added:
        </Paragraph>
      )}
      {filters
        .filter(() => {
          // Decide whether or not to show the filters
          if (isShared) {
            // On shared page(s)
            return enabledControls?.includes('audience-filters') || false;
          }
          // Show all filters by default
          return true;
        })
        .map((filter: GroupedFilters) => {
          return (
            <FilterPill
              filter={filter}
              clearFilters={clearFilters}
              key={`${filter.platform}-${filter.filterType}`}
            />
          );
        })}

      <AppliedCreatorFilters newFilterPill={newFilterPill} />
    </Flex>
  );
};
